import {firestore, getTeamId} from '../firebase';
import {mapSnapshot} from "../api";

export const FETCH_USER = "FETCH_USER";
export const RESET_ACTIVE_USER = "RESET_ACTIVE_USER";
export function fetchUser(userId, key){
    return {
        type: FETCH_USER,
        meta: {key},
        payload: firestore
            .doc('users/' + userId)
            .get()
            .then(sh => mapSnapshot(sh))
    }
}
export function setActiveUser(userId) {
    if(userId){
        return fetchUser(userId, "active");
    }else{
        return {
            type: RESET_ACTIVE_USER
        }
    }
}


export const FETCH_USERS = "FETCH_USERS";
export function fetchUsers(){
    return {
        type: FETCH_USERS,
        payload: firestore
            .collection("users")
            .where("teamId", "==", getTeamId())
            .where("activated", "==", true)
            .get().then(sh => mapSnapshot(sh))
    };
}
export function fetchUsersIfNeeded(){
    return (dispatch, state) => {
        const {users} = state();
        if(!users.fetching && !users.fetched){
            dispatch(fetchUsers());
        }
    };
}

export const UPDATE_USER = "UPDATE_USER";
export function updateUser(userId, data){
    return {
        type: UPDATE_USER,
        meta: {key: userId},
        payload: firestore
            .doc("users/" + userId)
            .update(data)
            .then(() => data)
    }
}

export function activateUser(userId, active=true){
    return async (dispatch, state) => {
        await firestore
            .doc("users/" + userId)
            .update({active});

        dispatch(fetchUsers());
    }
}
export function deactivateUser(user){
    return activateUser(user, false);
}


// WEBPACK FOOTER //
// ./src/actions/UserActions.js